import React from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { IoCallSharp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import {
  toggleSidebar,
  toogleConversation,
} from "../../Redux/reducers/responsiveHandle";

export default function ChatNavigationBar({ name, avatar, number }) {
  const dispatch = useDispatch();
  return (
    <div className="chat-nav">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <AiOutlineLeft
          size={20}
          color="#ec008c"
          onClick={() => {
            dispatch(toggleSidebar());
            dispatch(toogleConversation());
          }}
          className="back-btn"
        />
        <img src={avatar} alt="user-profile" />
        <h6>{name}</h6>
      </div>

      <div>
        <a href={`tel:${number}`}>
          <IoCallSharp
            color="#ec008c"
            size={25}
            style={{ cursor: "pointer", border: '1px solid #ec008c', borderRadius: '50%', padding: 4 }}
          />
        </a>
        {/* <BsThreeDotsVertical color="#ec008c" size={25} /> */}
      </div>
    </div>
  );
}
